import React from 'react';

const GlassCard = ({ hover = true, className = '', children, ...rest }) => (
  <div
    className={`rounded-card border border-white/[.08] bg-surface transition-colors duration-200 ${
      hover ? 'hover:border-white/15' : ''
    } ${className}`}
    {...rest}
  >
    {children}
  </div>
);

export default GlassCard;
